import { createAction } from '@reduxjs/toolkit';

export const subscribeUpdateId = createAction('subscribe/updateId');
export const subscribeUpdateUID = createAction('subscribe/updateUID');
export const subscribeUpdateSID = createAction('subscribe/updateSID');
export const subscribeUpdateIsAdded = createAction('subscribe/updateIsAdded');
export const subscribeUpdateIsActive = createAction('subscribe/updateIsActive');

export const subscribeStore = createAction('subscribe/store');
export const subscribeClear = createAction('subscribe/clear');

export const subscribeUpdateRequest = createAction('subscribe/updateRequest');
export const subscribeUpdateError = createAction('subscribe/updateError');
export const subscribeUpdateStore = createAction('subscribe/updateStore');

export const subscribeUpdateSectionTitle = createAction('subscribe/updateSectionTitle');
export const subscribeUpdateButtonTitle = createAction('subscribe/updateButtonTitle');
export const subscribeUpdateSubmitText = createAction('subscribe/updateSubmitText');
export const subscribeUpdateViewType = createAction('subscribe/updateViewType');
export const subscribeUpdateCollectType = createAction('subscribe/updateCollectType');
export const subscribeUpdateThanksMessage = createAction('subscribe/updateThanksMessage');

export const subscribeUpdateIsEmail = createAction('subscribe/updateIsEmail');
export const subscribeUpdateIsInstagram = createAction('subscribe/updateIsInstagram');
export const subscribeUpdateIsMessenger = createAction('subscribe/updateIsMessenger');
export const subscribeUpdateIsPhone = createAction('subscribe/updateIsPhone');
export const subscribeUpdateIsTelegram = createAction('subscribe/updateIsTelegram');
export const subscribeUpdateIsWhatsApp = createAction('subscribe/updateIsWhatsApp');
export const subscribeUpdateIsViber = createAction('subscribe/updateIsViber');

export const subscribeUpdateEmailPlaceholder = createAction('subscribe/updateEmailPlaceholder');
export const subscribeUpdateEmailFileUrl = createAction('subscribe/updateEmailFileUrl');
export const subscribeUpdateEmailResultType = createAction('subscribe/updateEmailResultType');
export const subscribeUpdatePhonePlaceholder = createAction('subscribe/updatePhonePlaceholder');
export const subscribeUpdatePhoneFileUrl = createAction('subscribe/updatePhoneFileUrl');
export const subscribeUpdatePhoneResultType = createAction('subscribe/updatePhoneResultType');

export const subscribeUpdateInstagramPlaceholder = createAction('subscribe/updateInstagramPlaceholder');
export const subscribeUpdateInstagramUrl = createAction('subscribe/updateInstagramUrl');
export const subscribeUpdateInstagramResultType = createAction('subscribe/updateInstagramResultType');
export const subscribeUpdateMessengerPlaceholder = createAction('subscribe/updateMessengerPlaceholder');
export const subscribeUpdateMessengerUrl = createAction('subscribe/updateMessengerUrl');
export const subscribeUpdateMessengerResultType = createAction('subscribe/updateMessengerResultType');
export const subscribeUpdateTelegramPlaceholder = createAction('subscribe/updateTelegramPlaceholder');
export const subscribeUpdateTelegramUrl = createAction('subscribe/updateTelegramUrl');
export const subscribeUpdateTelegramResultType = createAction('subscribe/updateTelegramResultType');
export const subscribeUpdateWhatsAppPlaceholder = createAction('subscribe/updateWhatsAppPlaceholder');
export const subscribeUpdateWhatsAppUrl = createAction('subscribe/updateWhatsAppUrl');
export const subscribeUpdateWhatsAppResultType = createAction('subscribe/updateWhatsAppResultType');
export const subscribeUpdateViberPlaceholder = createAction('subscribe/updateViberPlaceholder');
export const subscribeUpdateViberUrl = createAction('subscribe/updateViberUrl');
export const subscribeUpdateViberResultType = createAction('subscribe/updateViberResultType');

export const subscribeUpdateSubmitButtonText = createAction('subscribe/updateSubmitButtonText');
export const subscribeUpdateBackgroundColor = createAction('subscribe/updateBackgroundColor');
export const subscribeUpdateTextColor = createAction('subscribe/updateTextColor');
export const subscribeUpdateIsBorder = createAction('subscribe/updateIsBorder');
export const subscribeUpdateOpacity = createAction('subscribe/updateOpacity');
export const subscribeUpdateIsFullWidth = createAction('subscribe/updateIsFullWidth');
export const subscribeUpdateShadow = createAction('subscribe/updateShadow');
export const subscribeUpdateMargin = createAction('subscribe/updateMargin');
export const subscribeUpdatePadding = createAction('subscribe/updatePadding');

export const subscribeUpdateTitle = createAction('subscribe/updateTitle');
export const subscribeUpdateTitleColor = createAction('subscribe/updateTitleColor');
export const subscribeUpdateDescription = createAction('subscribe/updateDescription');
export const subscribeUpdateTextAlign = createAction('subscribe/updateTextAlign');
export const subscribeUpdateImage = createAction('subscribe/updateImage');

export const subscribeUpdateButtonText = createAction('subscribe/updateButtonTitle');
export const subscribeUpdateButtonBackgroundColor = createAction('subscribe/updateButtonBackgroundColor');
export const subscribeUpdateButtonTextColor = createAction('subscribe/updateButtonTextColor');
export const subscribeUpdateButtonOpacity = createAction('subscribe/updateButtonOpacity');
export const subscribeUpdateButtonBorder = createAction('subscribe/updateButtonBorder');
export const subscribeUpdateButtonBorderColor = createAction('subscribe/updateButtonBorderColor');
export const subscribeUpdateButtonShadow = createAction('subscribe/updateButtonShadow');
export const subscribeUpdateButtonShadowColor = createAction('subscribe/updateButtonShadowColor');
export const subscribeUpdateButtonShape = createAction('subscribe/updateButtonShape');

export const subscribeUpdateHeadingTitle = createAction('subscribe/updateHeadingTitle');
export const subscribeUpdateHeadingDescription = createAction('subscribe/updateHeadingDescription');
export const subscribeUpdateHeadingTextAlign = createAction('subscribe/updateHeadingTextAlign');
export const subscribeUpdateHeadingImage = createAction('subscribe/updateHeadingImage');
export const subscribeUpdateHeadingDivider = createAction('subscribe/updateHeadingDivider');

export const subscribeUpdateSectionIsBackground = createAction('subscribe/updateSectionIsBackground');
export const subscribeUpdateSectionTextColor = createAction('subscribe/updateSectionTextColor');
export const subscribeUpdateSectionBackgroundColor = createAction('subscribe/updateSectionBackgroundColor');
export const subscribeUpdateSectionOpacity = createAction('subscribe/updateSectionOpacity');
export const subscribeUpdateSectionIsFullWidth = createAction('subscribe/updateSectionIsFullWidth');
export const subscribeUpdateSectionShadow = createAction('subscribe/updateSectionShadow');
export const subscribeUpdateSectionShadowColor = createAction('subscribe/updateSectionShadowColor');
export const subscribeUpdateSectionPadding = createAction('subscribe/updateSectionPadding');
export const subscribeUpdateSectionMargin = createAction('subscribe/updateSectionMargin');
export const subscribeUpdateSectionBackgroundType = createAction('subscribe/updateSectionBackgroundType');
export const subscribeUpdateSectionBackgroundImage = createAction('subscribe/updateSectionBackgroundImage');
export const subscribeUpdateSectionGradientColor1 = createAction('subscribe/updateSectionGradientColor1');
export const subscribeUpdateSectionGradientColor2 = createAction('subscribe/updateSectionGradientColor2');
export const subscribeUpdateSectionGradientDirection = createAction('subscribe/updateSectionGradientDirection');
export const subscribeUpdateSectionGradientOffset = createAction('subscribe/updateSectionGradientOffset');
export const subscribeUpdateSectionBorder = createAction('subscribe/updateSectionBorder');
export const subscribeUpdateSectionBorderColor = createAction('subscribe/updateSectionBorderColor');
export const subscribeUpdateSectionShadowBorderColor = createAction('subscribe/updateSectionShadowBorderColor');
export const subscribeUpdateSectionShape = createAction('subscribe/updateSectionShape');

export const subscribeUpdateItems = createAction('subscribe/updateItems');

export const subscribeSortedItems = createAction('subscribe/sortedItems');
